// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#fff","menuText":"#001528","menuActiveText":"#5373e0"};